// Geo-aware currency detection. Resolves an ISO 4217 code + symbol from the
// browser locale on first run, then persists the user's effective choice.

const SYMBOLS = {
  USD: "$", CAD: "C$", EUR: "€", GBP: "£", AUD: "A$", NZD: "NZ$",
  JPY: "¥", CNY: "¥", INR: "₹", CHF: "CHF", SEK: "kr", NOK: "kr",
  DKK: "kr", PLN: "zł", CZK: "Kč", HUF: "Ft", RUB: "₽", BRL: "R$",
  MXN: "MX$", ZAR: "R", AED: "AED", SAR: "SAR", SGD: "S$", HKD: "HK$",
  KRW: "₩", THB: "฿", TWD: "NT$", IDR: "Rp", MYR: "RM", PHP: "₱",
  VND: "₫", TRY: "₺", ILS: "₪", ARS: "AR$", CLP: "CL$", COP: "CO$",
  PEN: "S/", UAH: "₴",
};

const LOCALE_TO_CURRENCY = {
  US: "USD", CA: "CAD", GB: "GBP", UK: "GBP", IE: "EUR", AU: "AUD",
  NZ: "NZD", JP: "JPY", CN: "CNY", HK: "HKD", TW: "TWD", KR: "KRW",
  SG: "SGD", MY: "MYR", TH: "THB", PH: "PHP", ID: "IDR", VN: "VND",
  IN: "INR", PK: "INR", LK: "INR",
  DE: "EUR", FR: "EUR", IT: "EUR", ES: "EUR", PT: "EUR", NL: "EUR",
  BE: "EUR", AT: "EUR", FI: "EUR", GR: "EUR", LU: "EUR", SK: "EUR",
  SI: "EUR", EE: "EUR", LV: "EUR", LT: "EUR", MT: "EUR", CY: "EUR",
  CH: "CHF", SE: "SEK", NO: "NOK", DK: "DKK", IS: "DKK",
  PL: "PLN", CZ: "CZK", HU: "HUF", RU: "RUB", UA: "UAH",
  BR: "BRL", AR: "ARS", MX: "MXN", CL: "CLP", CO: "COP", PE: "PEN",
  ZA: "ZAR", AE: "AED", SA: "SAR", IL: "ILS", TR: "TRY",
};

export function detectCurrency() {
  try {
    const locale = (typeof navigator !== "undefined" && (navigator.language || navigator.languages?.[0])) || "en-US";
    // Country region from "en-GB" → "GB"
    const region = locale.split("-")[1]?.toUpperCase();
    if (region && LOCALE_TO_CURRENCY[region]) {
      const code = LOCALE_TO_CURRENCY[region];
      return { currency: code, symbol: SYMBOLS[code] || code };
    }
    // Fall back to Intl resolved currency
    const fmt = new Intl.NumberFormat(locale, { style: "currency", currency: "USD" });
    const parts = fmt.formatToParts(1);
    const sym = parts.find((p) => p.type === "currency")?.value || "$";
    return { currency: "USD", symbol: sym };
  } catch {
    return { currency: "USD", symbol: "$" };
  }
}

export function symbolFor(code) {
  return SYMBOLS[code] || code || "$";
}

export function fmtMoney(amount, symbol = "$", digits = 0) {
  if (amount === null || amount === undefined || !isFinite(amount)) return `${symbol}—`;
  const v = Math.abs(amount).toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
  return `${amount < 0 ? "-" : ""}${symbol}${v}`;
}
